import React from 'react';
import { Modal } from 'react-bootstrap';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';

type RequestApprovalSuccessModalProps = {
  show: boolean;
  onHide: () => void;
  draftName: string;
  editedBy: string;
  incidentId: string | null;
};

const RequestApprovalSuccessModal: React.FC<
  RequestApprovalSuccessModalProps
> = ({ show, onHide, draftName, editedBy, incidentId }) => {
  const isAorOnly = !incidentId;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>
          Approval Requested
          <small
            className="fw-normal text-muted d-block mt-1"
            style={{ wordBreak: 'normal' }}
          >
            Draft <b>{draftName}</b> by <b>{editedBy}</b> has been submitted.
            Here&apos;s what happens next:
          </small>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isAorOnly ? (
          <div>
            <div className="border rounded p-2">
              <div>Review and Approval</div>
              <div>
                Every user with permission to approve SITREPs for {draftName}{' '}
                has been notified.
              </div>
              <div className="mt-2">
                Any of those reviewers can open this draft and either{' '}
                <b>approve</b> or <b>reject</b> it - no fixed sequence or
                hand-off is required
              </div>
            </div>
            <div className="mt-2">
              You&apos;ll be notified as each reviewer takes action. Track
              progress under the <b>Drafts</b> tab.
            </div>
          </div>
        ) : (
          <div>
            <div>Approval Workflow for Incident SITREPs</div>
            <ol className="mt-2">
              <li>
                All users assigned to the <b>Situation Unit Leader</b> position
                are notified to complete the first review.
              </li>
              <li className="mt-2">
                Once the first review is complete, the draft routes to all users
                assigned to the <b>Planning Section Chief</b> position for
                review and approval.
              </li>
            </ol>
            <div className="mt-2">
              Any user assigned to the <b>Incident Commander</b> position can
              review and approve this draft at any point, regardless of where it
              is in the workflow above or the actions of the other reviewers.
            </div>
            <div className="mt-2">
              You&apos;ll be notified as each reviewer takes action. Track
              progress under the <b>Drafts</b> tab.
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <StylishNewButton
          type="button"
          className="button--primary"
          onClick={onHide}
        >
          OK
        </StylishNewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default RequestApprovalSuccessModal;
